// ==============API CREATION OF AUTOMESSAGE ================
export const AUTOMESSAGE_CREATE_REQUEST = 'automessage create request'
export const AUTOMESSAGE_CREATE_SUCCESS = 'automessage create success'
export const AUTOMESSAGE_CREATE_FAILURE= 'automessage create failure'
// ==============API READ OF AUTOMESSAGE ================
export const AUTOMESSAGE_READ_REQUEST = 'automessage read requested'
export const AUTOMESSAGE_READ_SUCCESS = 'automessage read succeeded'
export const AUTOMESSAGE_READ_FAILURE= 'automessage read failed'
// ==============API UPDATE OF AUTOMESSAGE ================
export const AUTOMESSAGE_UPDATE_REQUEST = 'automessage update request'
export const AUTOMESSAGE_UPDATE_SUCCESS = 'automessage update success'
export const AUTOMESSAGE_UPDATE_FAILURE= 'automessage update failure'
// ==============API DELETION OF AUTOMESSAGE ================
export const AUTOMESSAGE_DELETE_REQUEST = 'automessage delete request'
export const AUTOMESSAGE_DELETE_SUCCESS = 'automessage delete success'
export const AUTOMESSAGE_DELETE_FAILURE= 'automessage delete failure'
// ==============API create OF AUTOMESSAGE ================

export function automessageCreateRequest() {
  return {
    type: AUTOMESSAGE_CREATE_REQUEST
  }
}


export function automessageCreateSuccess(automessages) {
  return {
    type: AUTOMESSAGE_CREATE_SUCCESS,
    automessages: automessages,
  }
}

export function automessageCreateFailure(error, response) {
  return {
    type: AUTOMESSAGE_CREATE_FAILURE,
    error: error,
    response: response
  }
}


// ==============API read OF AUTOMESSAGE ================
export function automessageReadRequest() {
  return {type: AUTOMESSAGE_READ_REQUEST}
}

export function automessageReadSuccess(automessages) {
  return {
    type: AUTOMESSAGE_READ_SUCCESS,
    automessages: automessages,
  }
}

export function automessageReadFailure(error, response) {
  return {
    type: AUTOMESSAGE_READ_FAILURE,
    error: error,
    response: response
  }
}

// ==============API UPDATE OF AUTOMESSAGE ================
export function automessageUpdateRequest(isFetching) {
  return {
    type: AUTOMESSAGE_UPDATE_REQUEST,
    isFetching: isFetching,
  }
}

export function automessageUpdateSuccess(automessages) {
  return {
    type: AUTOMESSAGE_UPDATE_SUCCESS,
    automessages: automessages,
  }
}

export function automessageUpdateFailure(error, response) {
  return {
    type: AUTOMESSAGE_UPDATE_FAILURE,
    error: error,
    response: response
  }
}

// ==============API DELETION OF AUTOMESSAGE ================
export function automessageDeleteRequest(isFetching) {
  return {
    type: AUTOMESSAGE_DELETE_REQUEST,
    isFetching: isFetching,
  }
}

export function automessageDeleteSuccess(automessages) {
  return {
    type: AUTOMESSAGE_DELETE_SUCCESS,
    automessages: automessages,
  }
}

export function automessageDeleteFailure(error, response) {
  return {
    type: AUTOMESSAGE_DELETE_FAILURE,
    error: error,
    response: response
  }
}



// WEBPACK FOOTER //
// ./src/model/AutoMessage/actions.js